import React, { useEffect } from "react";

export function usePresenceChanges(data, field, setModalData, modalTitle, resetStoreField, openModal) {
  useEffect(() => {
    if (data.get(field)) {
      setModalData({
        title: modalTitle,
        content: data.get(field),
        afterClose: () => {
          resetStoreField();
          openModal(false);
        },
      });
      openModal(true);
    }
  }, [data]);
}



// WEBPACK FOOTER //
// src/hooks/usePresenceChanges.js